export const userColumns = [
  {
    field: 'user',
    headerName: 'User',
    width: 330,
    renderCell: (params) => {
      // Use default avatar if no image available
      const imageUrl =
        params.row.img_url ||
        params.row.img ||
        'https://via.placeholder.com/40x40?text=👤';

      return (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={imageUrl}
            alt="avatar"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/40x40?text=👤';
            }}
          />
          {params.row.display_name || 'No Name'}
        </div>
      );
    },
  },
  // {
  //   field: 'membership_code',
  //   headerName: 'Membership Code',
  //   width: 180,
  // },
  {
    field: 'address',
    headerName: 'Address',
    width: 250,
    renderCell: (params) => {
      return <div>{params.row.address || 'No Address'}</div>;
    },
  },
  // {
  //   field: 'phone',
  //   headerName: 'Phone',
  //   width: 170,
  //   renderCell: (params) => {
  //     return <div>{params.row.phone || 'No Phone'}</div>;
  //   },
  // },
  {
    field: 'share_amount',
    headerName: 'Share Amount',
    width: 150,
    renderCell: (params) => {
      return (
        <div>GH₵ {parseFloat(params.row.share_amount || 0).toFixed(2)}</div>
      );
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status || 'unknown'}
        </div>
      );
    },
  },
];
